<template>
  <emd-card-content customClass="eu-pa_3">
    <div class="emd-panel">
      <div class="emd-panel__section">
        <div class="emd-panel__block">
          <div class="el-chunk">
            <emd-text
              type="caption"
              size="medium"
              tag="h2"
              >{{ $t('invite.detail.personal-data') }}</emd-text
            >
          </div>
        </div>
        <div class="emd-panel__block">
          <div class="el-chunk">
            <emd-text
              variation-color="subtle"
              type="label"
              size="tiny"
              tag="p"
              >{{ $t('invite.detail.name') }}</emd-text
            >
            <emd-text size="medium">{{ invite.invited_name }}</emd-text>
          </div>
          <div class="el-chunk">
            <emd-text
              variation-color="subtle"
              type="label"
              size="tiny"
              tag="p"
            >
              {{ $t('invite.detail.email') }}
            </emd-text>
            <emd-text size="medium">{{ invite.invited_email }}</emd-text>
          </div>
        </div>
      </div>
    </div>
    <div class="emd-panel">
      <div class="emd-panel__section">
        <div class="emd-panel__block">
          <div class="el-chunk">
            <emd-text
              type="caption"
              size="medium"
              tag="h2"
              >{{ $t('invite.detail.inviter') }}</emd-text
            >
          </div>
        </div>
        <div class="emd-panel__block">
          <div class="el-chunk">
            <emd-text
              variation-color="subtle"
              type="label"
              size="tiny"
              tag="p"
            >
              {{ $t('invite.detail.inviter-name') }}
            </emd-text>
            <emd-text size="medium">{{ invite.inviter_name }}</emd-text>
          </div>
          <div class="el-chunk">
            <emd-text
              variation-color="subtle"
              type="label"
              size="tiny"
              tag="p"
            >
              {{ $t('invite.detail.inviter-email') }}
            </emd-text>
            <emd-text size="medium">{{ invite.inviter_email }}</emd-text>
          </div>
        </div>
      </div>
    </div>
  </emd-card-content>
</template>
<script>
import { EmdCardContent, EmdText } from 'emerald-vue/src/components'

export default {
  name: 'InviteDetailInfos',

  components: {
    EmdCardContent,
    EmdText
  },

  props: {
    invite: Object
  }
}
</script>
